import { defineStore } from "pinia";
const diffDay = (time: string) => {
  const created_at = new Date(time);
  const today = new Date();
  const timeDiff = today.getTime() - created_at.getTime();
  return Math.floor(timeDiff / (1000 * 3600 * 24));
};

export const useLimit = defineStore({
  id: "limit-store",
  state: () => {
    return {
      modal: false,
    };
  },
  actions: {
    checkLimit(type: string) {
      const qrcodes = useQrStyle().GetStacKSession();
      var counter = 0;
      for (let i = 0; i < qrcodes.length; i++) {
        if (qrcodes[i].type == type) {
          const d = diffDay(qrcodes[i].created_at);
          if (d <= 1) {
            counter++;
          }
        }
      }
      if (counter >= 2) {
        this.modal = true;
        return true;
      }
      return false;
    },
  },
  getters: {},
});
